import { render } from "./AdminSistema.vue?vue&type=template&id=786aec6c"
import script from "./AdminSistema.vue?vue&type=script&lang=js"
export * from "./AdminSistema.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__